var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    ref: "modal",
    attrs: {
      "width": 640,
      "title": _vm.title
    },
    model: {
      value: _vm.modalVisible,
      callback: function callback($$v) {
        _vm.modalVisible = $$v;
      },
      expression: "modalVisible"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "myform",
    attrs: {
      "model": _vm.data,
      "rules": _vm.rules,
      "label-width": 100,
      "showMessage": false,
      "autocomplete": "off",
      "novalidate": ""
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "pass",
      "label": "设置新密码"
    }
  }, [_c('IInput', {
    attrs: {
      "type": "password"
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('pass');
      }
    },
    model: {
      value: _vm.data.pass,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "pass", $$v);
      },
      expression: "data.pass"
    }
  })], 1)], 1), _c('template', {
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "loading": _vm.loading,
      "disabled": !_vm.isFormValid
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("确定")]), _c('Button', {
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1)], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };